<template>
	<div class="container__login">
		<div class="container__login__main">
			<div class="container__login__main__panel">
				<img
					src="../../assets/treevia_login.png"
					alt
					class="container__login__main__panel__logo"
				/>
				<LoginForm
					v-if="step === 'login'"
					:set-step="setStep"
				/>
				<RecoverForm
					v-else-if="step === 'recover'"
					:set-step="setStep"
				/>
				<RecoverSuccess
					v-else-if="step === 'recover-success'"
					:set-step="setStep"
				/>
			</div>
		</div>
		<div class="container__login__footer">
			<Footer />
		</div>
	</div>
</template>

<script>
import Footer from '../../components/Footer/Footer'
import LoginForm from './LoginForm/LoginForm'
import RecoverForm from './RecoverForm/RecoverForm'
import RecoverSuccess from './RecoverSuccess/RecoverSuccess'
export default {
	components: {
		Footer,
		LoginForm,
		RecoverForm,
		RecoverSuccess,
	},
	data: function () {
		return {
			step: 'login',
		}
	},
	beforeCreate() {
		localStorage.removeItem('jwt')
		localStorage.removeItem('email')
		localStorage.removeItem('username')
		localStorage.removeItem('user-modules')
		localStorage.removeItem('fotoUrl')
	},
	methods: {
		setStep(step) {
			this.step = step
		},
	},
}
</script>

<style scoped>
.container__login {
	display: grid;
	grid-template-areas: 'main' 'footer';
	background-color: white;
	width: 100%;
}

.container__login__main {
	grid-area: main;
	height: calc(100vh - 2.5rem);
	display: flex;
	justify-content: center;
	align-items: center;
}

.container__login__main__panel {
	height: auto;
	width: 100%;
	max-width: 30rem;
	padding: 1.87rem;
	margin: 0 1rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	animation: container__login__main__panel__animation 1s ease-in-out;
}

@keyframes container__login__main__panel__animation {
	from {
		opacity: 0;
		transform: translateY(-20px);
	}

	to {
		opacity: 1;
		transform: translateY(0px);
	}
}

.container__login__main__panel__logo {
	max-width: 100%;
}

.container__login__footer {
	grid-area: footer;
	height: 2.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
}

@media screen and (min-width: 768px) {
	.container__login {
		background-color: var(--color-background);
	}
	.container__login__main__panel {
		background-color: white;
		border-radius: 5px;
		width: 30rem;
		padding: 2.5rem 3.12rem;
	}
}
</style>
